import { Component } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'app-coppr-info.component',
  imports: [
    RouterLink, 
    RouterLinkActive
  ],
  templateUrl: './coppr-info.component.html',
  styleUrl: './coppr-info.component.scss'
})
export class CopprInfoComponent {

}
